import { render, staticRenderFns } from "./customCases.vue?vue&type=template&id=2c24ffb8"
import script from "./customCases.vue?vue&type=script&lang=js"
export * from "./customCases.vue?vue&type=script&lang=js"
import style0 from "./customCases.vue?vue&type=style&index=0&id=2c24ffb8&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c24ffb8')) {
      api.createRecord('2c24ffb8', component.options)
    } else {
      api.reload('2c24ffb8', component.options)
    }
    module.hot.accept("./customCases.vue?vue&type=template&id=2c24ffb8", function () {
      api.rerender('2c24ffb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/solution/SecuritiesSolutions/components/customCases.vue"
export default component.exports